<main *ngIf="articleHubInfo">
  <eds-banner-standard
    *ngIf="articleHubInfo"
    theme="primary"
    [edsSpacing]="stickyTabs ? 'auto' : 'xxl'"
    [breadcrumbItems]="breadcrumbItems"
    [preTitle]="articleHubInfo.preTitle"
    [title]="articleHubInfo.title"
    [titleLevel]="1"
    [titleSize]="'h1'"
    [wide]="true"
  >
  </eds-banner-standard>

  <div
    *ngIf="stickyTabs"
    [ngClass]="!page?.isPreview() ? 'insights-sticky-tabs' : ''"
  >
    <div edsSpacing="xl">
      <eds-tabs-sticky
        [links]="stickyTabs"
        [activeTab]="activeTabId"
        (onTabChanged)="onTabChange($event)"
        (onHeightChanged)="onHeightChange($event)"
      ></eds-tabs-sticky>
    </div>
  </div>

  <section edsGrid edsSpacing="xxl" *ngIf="articleHubInfo">
    <div class="container container--wide">
      <div edsSpacing="xl" edsRow edsFlexbox justifyContent="space-between">
        <div
          edsCol
          edsSubGrid="layout-3"
          edsSubGridTablet="layout-3"
          edsSubGridGap="md"
          edsSubGridTabletGap="md"
        >
          <div
            id="intro"
            class="ck-editor"
            *ngIf="articleHubInfo.summary?.value"
          >
            <div [innerHTML]="articleHubInfo.summary?.value"></div>
          </div>
          <div
            *ngIf="articleHubInfo.imageSrc"
            edsFlexbox
            [justifyContent]="(isMobile$ | async) ? 'flex-start' : 'flex-end'"
            alignItems="center"
          >
            <eds-image [imgSrc]="articleHubInfo.imageSrc"></eds-image>
          </div>
        </div>
      </div>
      <div edsRow>
        <div edsCol id="library">
          <ft-insights-library
            [compactImage]="true"
            [hideSidebars]="true"
            [externalTranslationLabel]="translationLabels"
            [hideLibraryHeader]="true"
            [preFilter]="articleHubInfo.articleFilters"
            [externalSIMLogoResource]="simLogoResourceBundle"
            [current]="''"
          ></ft-insights-library>
        </div>
      </div>
      <!-- Related Strategies -->
      <div edsRow *ngIf="relatedStrategies" id="strategies">
        <div edsCol>
          <ft-article-related-strategies
            [relatedStrategies]="relatedStrategies"
          ></ft-article-related-strategies>
        </div>
      </div>
      <!-- Related Strategies - END -->
    </div>
  </section>
</main>
